import {observer} from 'mobx-react'
import {Link, Outlet, useNavigate} from 'react-router-dom'
import {useEffect} from 'react'
import {PaymentService} from 'rest'

export const PrivateRoute = observer(() => {
  const navigate = useNavigate()
  const accountTypeError = false

  // if (!AuthStore.authenticated) navigate('/login')
  if (!localStorage.getItem('user')) navigate('/login')

  useEffect(() => {
    ;(async () => {
      let merchant = JSON.parse(localStorage.getItem('user'))?.store
      if (merchant) {
        await PaymentService.getSubscriptionProducts()
      }
    })()
    // eslint-disable-next-line
  }, [])

  return accountTypeError ? (
    <div className="flex justify-center items-center mt-20">
      <h2 className="text-xl py-2">
        OOPS! It seems you try to use your Promocodes account.
      </h2>
      <p className="py-2">
        You can not use this CouponCenter with your existed Promocodes account.
      </p>
      <p>
        Please{' '}
        <Link to="/logout" className="underline font-semibold">
          logout
        </Link>{' '}
        and create an CouponCenter account.
      </p>
    </div>
  ) : (
    <div className="container px-6 mx-auto">
      <Outlet />
    </div>
  )
})
